/** A bold title over a rule, opening each group of fields in the parcel details card. */
import FontBody2 from "../../../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../../../components/fonts/font-props";
import Hr from "../../../../../../../../../components/hr/hr";

interface IProps {
    title: string;
}

const SectionTitle: React.FC<IProps> = ({ title }) => (
    <>
        <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{title}</FontBody2>
        <Hr />
    </>
);

export default SectionTitle;
